import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findPackingItemList,
	changePackingItemActivePage,
	openPackingBoxNumberModal,
	findPackingItem
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['packingItemReducer', 'orderId']),
	data: state.getIn(['packingItemListReducer', 'packingItemList']),
	activePage: state.getIn(['packingItemListReducer', 'activePage']),
	itemPerPage: state.getIn(['packingItemListReducer', 'itemPerPage']),
	totalPage: state.getIn(['packingItemListReducer', 'totalPage']),
	pagingMaxButtons: 5,
	fields: {
		category: '群組',
		display_name: '類別',
		firefighter_division: '大隊',
		firefighter_squadron: '分隊',
		firefighter_title: '職稱',
		firefighter_name: '姓名',
		customer_gear_name: '產品名稱',
		color_display: '顏色',
		sizing_display: '尺寸',
		box_number: '箱號'
	},
	keys: ['order_item_id'],
	disableAdd: true,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: (pagingData) => {
		dispatch(findPackingItemList({ orderId: ownProps.orderId, boxNumber: ownProps.boxNumber }, pagingData));
	},
	changeActivepage: (pagingData, searchData) => {
		dispatch(changePackingItemActivePage(pagingData));
		dispatch(findPackingItemList({ orderId: ownProps.orderId, boxNumber: ownProps.boxNumber }, pagingData));
	},
	search: (pagingData, searchData) => {
		dispatch(findPackingItemList({ orderId: ownProps.orderId }, pagingData));
	},
	handleEdit: (pk) => {
		dispatch(findPackingItem({orderId: ownProps.orderId, boxNumber: ownProps.boxNumber}, pk));
		dispatch(openPackingBoxNumberModal());
	},
})

const PackingItemListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default PackingItemListContainer;


// WEBPACK FOOTER //
// ./src/containers/PackingItemListContainer.jsx